import { createContext } from "react";

export type PublicRaceLaunchPhase = "checking" | "prelaunch" | "live" | "error";

export type PublicRaceLaunchContextValue = {
  phase: PublicRaceLaunchPhase;
  hasPublicRaces: boolean;
  isResolved: boolean;
};

export const PUBLIC_LAUNCH_STATE_SCRIPT_ID = "rauxa-public-launch-state";

export const PublicRaceLaunchContext = createContext<PublicRaceLaunchContextValue | null>(null);

export const readEmbeddedLaunchPhase = (): PublicRaceLaunchPhase => {
  if (typeof document === "undefined") {
    return "checking";
  }

  const element = document.getElementById(PUBLIC_LAUNCH_STATE_SCRIPT_ID);
  if (!element?.textContent) {
    return "checking";
  }

  try {
    const value = JSON.parse(element.textContent) as { hasPublicRaces?: unknown };
    if (value.hasPublicRaces === true) {
      return "live";
    }
    if (value.hasPublicRaces === false) {
      return "prelaunch";
    }
  } catch {
    // A missing or malformed hint falls back to the authoritative Firestore snapshot.
  }

  return "checking";
};
